import React from 'react'

import { ButtonClean } from '@fourthwall/components'
import { routing } from '@utils/routing'

import * as S from './TermsFooter.styled'

export const TermsFooter = () => {
  return (
    <S.Container>
      By continuing, you agree to{' '}
      <ButtonClean
        to={routing.external.termsOfService}
        target="_blank"
        label="Terms of Use"
        appearance="secondary"
        withUnderline
      />{' '}
      applicable to Fourthwall Pro and confirm you have read our{' '}
      <ButtonClean
        to={routing.external.privacyPolicy}
        target="_blank"
        label="Privacy Policy"
        appearance="secondary"
        withUnderline
      />
    </S.Container>
  )
}
